export class AxisFile {
  public file: File;
  public src: any;
  public caption: string;
  public id: number;
  public icon: string;
}
